const apiKeyRegex = /SG(\.[^.]+){2,}/g;
const ipRegex =
  /(\d{1,3}\.(?:\d{1,3}|\*(?=\.\*))\.(?:\d{1,3}|\*(?=\.\*))\.(?:\d{1,3}|\*)(?:\/\d{1,2})?(?:\[.*?\])?)/g;

export const IP_REDACTED = "IP_REDACTED";
export const API_KEY_REDACTED = "API_KEY_REDACTED";

interface Redactions {
  searchValue: RegExp;
  replaceValue: string;
}

/*
 * Add more redactions here and they'll run against every string passed to redactSensitiveData.
 */
const redactions: Redactions[] = [
  {
    searchValue: apiKeyRegex,
    replaceValue: API_KEY_REDACTED,
  },
  {
    searchValue: ipRegex,
    replaceValue: IP_REDACTED,
  },
];

/** Redacts API keys and IP addresses from a string. Empty input is returned as-is. */
export const redactSensitiveData = (sourceString: string) => {
  if (!sourceString) {
    return sourceString;
  }
  return redactions.reduce(
    (result, { searchValue, replaceValue }) => result.replace(searchValue, replaceValue),
    sourceString
  );
};
